import { createLabeledMessages } from '../../../messageUtils';
const pdf = {
    load: 'Loading document',
    pageLoad: 'Loading page {{number}}',
    noData: 'No PDF file specified',
    pageNoData: 'No page specified',
    error: 'Failed to load the document',
    pageError: 'Failed to load page {{number}}'
};
export default Object.assign({}, pdf, createLabeledMessages(pdf));
